import { AfterViewInit, ChangeDetectionStrategy, Component, computed, ElementRef, inject, Injector, signal, viewChild } from '@angular/core';
import { CommonButtonRowWidget, CommonEmailField, CommonEmailFieldWidget, CommonForm, CommonTextFieldConfig } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { Email } from '@interfaces';
import { PersonDialogDataService } from '../../person-dialog-data.service';

@Component({
	selector: 'person-emails-part',
	standalone: true,
	imports: [
		CommonButtonRowWidget,
		CommonEmailFieldWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './emails.part.html'
})

export class EmailsPart implements AfterViewInit {

	public personDialogDataService = inject(PersonDialogDataService);
	private dialogService = inject(DialogService);

	public form = new CommonForm<{ email: string }>(inject(Injector));
	showForm = signal<boolean>(false);

	readonly emails = computed(() => this.personDialogDataService.personDetails()?.emails);

	public emailFormSaveBtn = viewChild.required<ElementRef<HTMLButtonElement>>('emailFormSaveBtn');

	ngAfterViewInit(): void {
		this.form.setSubmitButton(
			this.emailFormSaveBtn(),
			async (value, changed: string[]) => {
				this.personDialogDataService.addEmail(value.email);
				this.showForm.set(false);
			}
		);
	}

	showFormFunc(flag: boolean) {
		this.showForm.set(flag);
		this.form.resetAll();
		this.personDialogDataService.emailErrorMsg.set(undefined);
	}

	async confirmEmailDeletion(emailObj: Email) {
		const personDetails = this.personDialogDataService.personDetails();
		const { emailId, email, isDefault } = emailObj
		if (!isDefault) {
			const yes = await this.dialogService.confirm(`Do you want to remove ${email} from ${personDetails?.fullName} ?`, 'Yes', 'No', [], 400, 250);
			if (yes) {
				this.personDialogDataService.removeEmail(emailId);
			}
		}
	}

	changePrimaryEmail(emailId: number) {
		this.personDialogDataService.setPrimaryEmail(emailId);
	}

	readonly email = computed<CommonEmailField>(() => ({
		config: signal<CommonTextFieldConfig>({
			label: 'Email',
			isRequired: true,
			min: 5,
			fixCase: 'lower-case',
			multiLine: false,
		}),
		formFieldName: 'email',
		isExcluded: computed(() => !this.showForm()),
		form: this.form,
		actualValue: signal<string>(''),
		pendingValue: signal<string | null>(null),
		saving: signal(false),
		error: signal(''),
	}));

}